import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function DemoCard() {
  return (
    <StyledDemoCard className="learn_card">
      <div className="learn_card_body row">
        <div className="col-sm-12 col-md-auto mb-3">
          <div className="learn_card_title display-6 fw-bold">
            Готовы попробовать?
          </div>
          <div className="learn_card_subTitle fs-4 fw-bold">
            Регистрация не требуется
          </div>
        </div>
        <div className="col my-auto text-md-end">
          <Link to="#" className="learn_card_btn">
            Демо урок
          </Link>
        </div>
      </div>
    </StyledDemoCard>
  );
}

const StyledDemoCard = styled.div`
  margin-top: 3rem;
  padding: 3rem 1rem;
  box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%);
  background-color: #fff;
  border-radius: 0.25rem;

  .learn_card_body {
    padding: 1rem;
  }
  .learn_card_btn {
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    border-radius: 0.3rem;
    color: #0d6efd;
    font-weight: 400;
    line-height: 1.5;
    border: 1px solid #0d6efd;
    display: inline-flex;
  }
  .learn_card_subTitle {
    color: rgba(13, 110, 253, 1);
  }
  .learn_card_btn:hover {
    color: #fff;
    background-color: #0d6efd;
    border-color: #0d6efd;
  }

  @media (max-width: 567px) {
    padding: 1rem;
  }
`;
